import { Text } from "@chakra-ui/react";
import Font from "../Utils/Calligraphy";

const PageTitle = () => {
  return <Text fontFamily={Font.Bold} fontSize={32}>{`Credits`}</Text>;
};

export default PageTitle;
